import gql from 'graphql-tag';

export default gql`
  query XdpCourseDataQuery($slug: String!) {
    XdpV1Resource {
      slug(productType: "COURSE", slug: $slug) {
        elements {
          name
          id
          slug
          xdpMetadata {
            __typename
            ... on XdpV1_cdpMetadataMember {
              cdpMetadata {
                id
                courseTypeMetadata {
                  __typename
                }
              }
            }
          }
        }
      }
    }
  }
`;
